import { classnames, fDate } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ImportantNoteProps as Props } from './types';
import { Divider, Typography } from '@mui/material';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';

export const ImportantNote = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();

  return (
    <Styled.Wrapper
      className={classnames('ImportantNote', className)}
      sx={SX.root}
    >
      <Typography variant="body3" color="grey.700" fontWeight={500}>
        Important Note
      </Typography>

      <Divider sx={SX.divider} />
      <Typography variant="body4" fontWeight={400}>
        You will remain on your current plan, and your existing credits will
        carry
        <br /> over as usual. Your next billing cycle will begin on
        <Typography variant="body4" fontWeight={700} component="span">
          {' '}
          {fDate(data?.current?.currentPeriodEnd)}
        </Typography>
      </Typography>
    </Styled.Wrapper>
  );
});

ImportantNote.displayName = 'ImportantNote';
